import { render } from "./GraficoReservasPorCanal.vue?vue&type=template&id=56fbc652"
import script from "./GraficoReservasPorCanal.vue?vue&type=script&lang=js"
export * from "./GraficoReservasPorCanal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__